export enum Events {
  CHANGE = 'change',
}



// WEBPACK FOOTER //
// ./src/components/parts/catalog/list/count/enums.ts